import { styled, TableCell } from "@mui/material";

export const CustomTableFontCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  color: 'black',
  '&:hover': {
    color: 'black', 
  },
}));